import React from "react";
import { Box } from "../../design-system";
import { colors } from "../../design-system/colors";
import { CloseIcon, PencilIcon } from "../../design-system/icons";
import { EDIT_PROFILE_MODAL } from "../constants/accountText";

const CLOSE_BUTTON_SIZE = 32;

interface EditProfileHeaderProps {
  onClose: () => void;
}

const EditProfileHeader = ({ onClose }: EditProfileHeaderProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <PencilIcon size={18} color={colors.text[500]} />
      <Box
        component="span"
        sx={{
          fontFamily: "Outfit, sans-serif",
          fontSize: "24px",
          fontWeight: 700,
          lineHeight: "34px",
          color: colors.text[500],
        }}
      >
        {EDIT_PROFILE_MODAL.TITLE}
      </Box>
    </Box>

    <Box
      component="button"
      aria-label={EDIT_PROFILE_MODAL.CLOSE_ARIA_LABEL}
      onClick={onClose}
      sx={{
        width: `${CLOSE_BUTTON_SIZE}px`,
        height: `${CLOSE_BUTTON_SIZE}px`,
        borderRadius: "50%",
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        "&:hover": { backgroundColor: colors.button.iconButtonHoverBg },
        "&:focus-visible": {
          outline: `2px solid ${colors.primary[500]}`,
          outlineOffset: "2px",
        },
      }}
    >
      <CloseIcon size={18} color={colors.text[500]} />
    </Box>
  </Box>
);

export default EditProfileHeader;
